import * as fabric from 'office-ui-fabric-react';
import { getTheme } from 'office-ui-fabric-react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import * as models from '../../models';
import '../../styles/pages/AdministrationPage.scss';
import { setOrganizationName } from '../../utils';

interface IProps {
    organization: models.IOrganization;
}

const AdministrationOrganizationsGridItem: FC<IProps> = ({ organization }) => {
    const navigate = useNavigate();

    const handleInformationClick = () => {
        setOrganizationName(organization.name ?? '');
        navigate(`/administration/organization/${organization.id}/information`);
    };

    return (
        <div
            className="administrationPageItem"
            style={{ backgroundColor: getTheme().palette.themeLighterAlt }}
            onClick={() => handleInformationClick()}
        >
            <fabric.Text className="administrationPageItem-header-text" style={{ fontWeight: 'lighter' }} variant="xxLarge">
                {organization.name}
            </fabric.Text>
            <fabric.Stack.Item align="center">
                {organization.logoPreview && (
                    <div>
                        <hr />
                        <img style={{ maxHeight: '200px', maxWidth: '200px' }} src={organization.logoPreview} />
                    </div>
                )}
            </fabric.Stack.Item>
        </div>
    );
};

export default AdministrationOrganizationsGridItem;
